var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDynamicTrendDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48625 1.28151C6.48625 2.66795 6.48625 8.72302 6.48625 10.831C6.48625 11.0856 6.17825 11.213 5.99625 11.0149L1.61425 6.19064C1.41825 5.97843 1.08225 5.96429 0.872246 6.16235C0.662246 6.36041 0.648246 6.69995 0.844246 6.91216L6.62625 13.2785C6.83625 13.5048 7.20025 13.5048 7.39625 13.2785L13.1642 6.91216C13.3742 6.6858 13.3322 6.30382 13.0802 6.11991C12.8702 5.96429 12.5622 5.99258 12.3802 6.19064L7.99825 11.0149C7.83025 11.1988 7.50825 11.0856 7.50825 10.8168L7.50825 1.23906C7.50825 0.913675 7.21425 0.659022 6.89225 0.715612C6.65425 0.772202 6.48625 1.01271 6.48625 1.28151Z",
    fill: "#E092A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicTrendDown);
export default __webpack_public_path__ + "static/media/dynamic-trend-down.2ff2a76e.svg";
export { ForwardRef as ReactComponent };